
import apiClient from "../helpers/apiClient";

const API_RESTO_HOST = `/api/v2/transactions`
const api = apiClient();

export const getRankingLocal = () => api.get(`${API_RESTO_HOST}/ranking/local`);
export const getRankingGlobal = () => api.get(`${API_RESTO_HOST}/ranking/global`);
export const getRankingLocalByRestoId = (restoId) =>
  api.get(`${API_RESTO_HOST}/ranking/local/${restoId}`);
export const getRankingGlobalByRestoId = (restoId) =>
  api.get(`${API_RESTO_HOST}/ranking/global/${restoId}`);
export const getRankingCommuneByRestoId = (restoId) =>
  getRankingLocalByRestoId(restoId);
export const getRankingRegionalByRestoId = (restoId) =>
  api.get(`${API_RESTO_HOST}/ranking/regional/${restoId}`);
